import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useParamsControl } from '../../utils/useParamsControl'
import { AppTitlePage } from '../../components/AppTitlePage'
import { AppBtnColor } from '../../components/btn/AppBtn'
import { AllRoutes } from '../../core/routes/AllRoutes'
import { ShowFormatType } from './BuffetReportsVZ'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { GetFile } from '../../utils/getFile'
import { BASE_URL } from '../../core/api/BaseApi'
import {
  AppNotification,
  AppNotificationUpdate,
  NotificationType,
} from '../../components/notification/Notification'
import { AppLoader, LoaderType } from 'components/AppLoader'
import { useTranslation } from 'react-i18next'
import { useGetBuffetGeneralReportQuery } from 'core/api/BuffetReportApi'
import {
  IBuffetGeneralReportListDto,
  IBuffetGeneralReportRequest,
  IBuffetGeneralReportResult,
} from 'core/api/dto/BuffetGeneralReportDto'
import moment from 'moment'
import { ReportFull } from './components/ReportFull/ReportFull'
import { ReportVolume } from './components/ReportVolume/ReportVolume'
import { ReportTemperature } from './components/ReportTemperature/ReportTemperature'
import { ReportVisual } from './components/ReportVisual/ReportVisual'
import './BuffetReportsVZLine.scss'
import { DimensionTranslateType } from 'core/api/dto/BuffetReportDto'
import { GeneralReportImagePopup } from './components/GeneralReportPopup/GeneralReportImagePopup'
import { ReportIntensity } from './components/ReportIntensity/ReportIntensity'
import { createQueryStringSmart } from '../../utils/createQueryString'

type ReportExportType = 'base' | 'temp' | 'defect' | 'csv' | 'xsl'

const reportUrl: { [key in ReportExportType]: string } = {
  base: '/report_buffet/export_general_report_to_file/',
  temp: '/report_buffet/export_general_temperature_report/',
  defect: '/report_buffet/export_general_defect_report/',
  csv: '/report_buffet/export_general_report_to_file_csv/',
  xsl: '/report_buffet/export_general_take_report_to_excel/',
}

export const showFormatHeader = {
  [ShowFormatType.full]: 'По всем данным',
  [ShowFormatType.volume]: 'Объем выдаваемой продукции',
  [ShowFormatType.visual]: 'Визуальный',
  [ShowFormatType.intensity]: 'Интенсивность выдаваемой продукции',
  [ShowFormatType.temperature]: 'Температурный',
  [ShowFormatType.bi]: 'BI аналитика',
}

export const showStyleDimensionType = {
  [DimensionTranslateType.Serving as string]: 'match',
  [DimensionTranslateType.Refund as string]: 'refund',
  [DimensionTranslateType.Write_off as string]: 'no-match',
}

const onSortHandler = (
  sortValue: null | string,
  reportData: IBuffetGeneralReportResult[],
  summary: IBuffetGeneralReportResult,
  setReportData: React.Dispatch<
    React.SetStateAction<IBuffetGeneralReportResult[]>
  >,
) => {
  if (!sortValue) {
    setReportData([summary, ...reportData])
    return
  }

  const fieldName = sortValue.startsWith('-') ? sortValue.slice(1) : sortValue
  const isReverse = sortValue.startsWith('-')
  let newArr: IBuffetGeneralReportResult[] = []

  if (fieldName === 'name' || fieldName === 'categoryName') {
    newArr = [...reportData].sort((el1, el2) => {
      const val1 = `${
        el1[fieldName as keyof IBuffetGeneralReportResult] || ''
      }`.toLowerCase()
      const val2 = `${
        el2[fieldName as keyof IBuffetGeneralReportResult] || ''
      }`.toLowerCase()
      return isReverse ? (val1 < val2 ? 1 : -1) : val1 > val2 ? 1 : -1
    })
  } else {
    newArr = [...reportData].sort((el1, el2) => {
      const val1 = el1[fieldName as keyof IBuffetGeneralReportResult] || 0
      const val2 = el2[fieldName as keyof IBuffetGeneralReportResult] || 0
      return isReverse ? (val1 < val2 ? 1 : -1) : val1 > val2 ? 1 : -1
    })
  }

  setReportData([summary, ...newArr])

  // if (
  //   fieldName === 'complianceWithStandards' ||
  //   fieldName === 'aiPredictions'
  // ) {
  //   const sortedData = reportData.map((item) => ({
  //     ...item,
  //     dates: item.dates.map((date) => ({
  //       ...date,
  //       dimensions: [...date.dimensions].sort((el1, el2) => {
  //         if (fieldName === 'complianceWithStandards') {
  //           const getPriority = (val: string) => {
  //             switch (val) {
  //               case 'Non_compliant':
  //                 return 1
  //               case 'Not_determined':
  //                 return 2
  //               case 'Processing':
  //                 return 3
  //               case 'Absent_model':
  //                 return 4
  //               case 'Compliant':
  //                 return 5
  //               default:
  //                 return 6
  //             }
  //           }

  //           const priority1 = getPriority(el1.complianceWithStandards || '')
  //           const priority2 = getPriority(el2.complianceWithStandards || '')

  //           return isReverse ? priority2 - priority1 : priority1 - priority2
  //         } else {
  //           const arr1 = el1.aiPredictions || []
  //           const arr2 = el2.aiPredictions || []
  //           const hasData1 = Array.isArray(arr1) && arr1.length > 0 ? 1 : 0
  //           const hasData2 = Array.isArray(arr2) && arr2.length > 0 ? 1 : 0
  //           return isReverse ? hasData1 - hasData2 : hasData2 - hasData1
  //         }
  //       }),
  //     })),
  //   }))
  //   setReportData([summary, ...sortedData])
  //   return
  // }
  if (
    fieldName === 'complianceWithStandards' ||
    fieldName === 'aiPredictions'
  ) {
    const sortedData = reportData.map((item) => {
      // Сортируем dates внутри каждого блюда
      const sortedDates = item.dates.map((date) => {
        // Уровень 1: Сортируем dimensions внутри каждой даты
        const sortedDimensions = [...date.dimensions].sort((el1, el2) => {
          if (fieldName === 'complianceWithStandards') {
            const getPriority = (val: string) => {
              switch (val) {
                case 'Non_compliant':
                  return 1
                case 'Not_determined':
                  return 2
                case 'Processing':
                  return 3
                case 'Absent_model':
                  return 4
                case 'Compliant':
                  return 5
                default:
                  return 6
              }
            }

            const priority1 = getPriority(el1.complianceWithStandards || '')
            const priority2 = getPriority(el2.complianceWithStandards || '')

            return isReverse ? priority2 - priority1 : priority1 - priority2
          } else {
            const arr1 = el1.aiPredictions || []
            const arr2 = el2.aiPredictions || []
            const hasData1 = Array.isArray(arr1) && arr1.length > 0 ? 1 : 0
            const hasData2 = Array.isArray(arr2) && arr2.length > 0 ? 1 : 0
            return isReverse ? hasData1 - hasData2 : hasData2 - hasData1
          }
        })

        return {
          ...date,
          dimensions: sortedDimensions,
        }
      })

      // Уровень 2: Сортируем dates по агрегированному значению из dimensions
      const sortedDatesArray = [...sortedDates].sort((date1, date2) => {
        if (fieldName === 'complianceWithStandards') {
          const getPriority = (val: string) => {
            switch (val) {
              case 'Non_compliant':
                return 1
              case 'Not_determined':
                return 2
              case 'Processing':
                return 3
              case 'Absent_model':
                return 4
              case 'Compliant':
                return 5
              default:
                return 6
            }
          }

          // Берем минимальный приоритет (самый важный) из всех dimensions
          const minPriority1 = Math.min(
            ...date1.dimensions.map((d) =>
              getPriority(d.complianceWithStandards || ''),
            ),
          )
          const minPriority2 = Math.min(
            ...date2.dimensions.map((d) =>
              getPriority(d.complianceWithStandards || ''),
            ),
          )

          return isReverse
            ? minPriority2 - minPriority1
            : minPriority1 - minPriority2
        } else {
          // Для aiPredictions: есть ли хоть одна dimension с данными
          const hasData1 = date1.dimensions.some(
            (d) => Array.isArray(d.aiPredictions) && d.aiPredictions.length > 0,
          )
          const hasData2 = date2.dimensions.some(
            (d) => Array.isArray(d.aiPredictions) && d.aiPredictions.length > 0,
          )
          const val1 = hasData1 ? 1 : 0
          const val2 = hasData2 ? 1 : 0
          return isReverse ? val1 - val2 : val2 - val1
        }
      })

      return {
        ...item,
        dates: sortedDatesArray,
      }
    })

    // Уровень 3: Сортируем сами блюда по агрегированному значению из dates
    const finalSortedData = [...sortedData].sort((item1, item2) => {
      if (fieldName === 'complianceWithStandards') {
        const getPriority = (val: string) => {
          switch (val) {
            case 'Non_compliant':
              return 1
            case 'Not_determined':
              return 2
            case 'Processing':
              return 3
            case 'Absent_model':
              return 4
            case 'Compliant':
              return 5
            default:
              return 6
          }
        }

        // Берем минимальный приоритет из всех dates->dimensions
        const minPriority1 = Math.min(
          ...item1.dates.flatMap((date) =>
            date.dimensions.map((d) =>
              getPriority(d.complianceWithStandards || ''),
            ),
          ),
        )
        const minPriority2 = Math.min(
          ...item2.dates.flatMap((date) =>
            date.dimensions.map((d) =>
              getPriority(d.complianceWithStandards || ''),
            ),
          ),
        )

        return isReverse
          ? minPriority2 - minPriority1
          : minPriority1 - minPriority2
      } else {
        // Для aiPredictions: есть ли хоть одна dimension с данными во всех dates
        const hasData1 = item1.dates.some((date) =>
          date.dimensions.some(
            (d) => Array.isArray(d.aiPredictions) && d.aiPredictions.length > 0,
          ),
        )
        const hasData2 = item2.dates.some((date) =>
          date.dimensions.some(
            (d) => Array.isArray(d.aiPredictions) && d.aiPredictions.length > 0,
          ),
        )
        const val1 = hasData1 ? 1 : 0
        const val2 = hasData2 ? 1 : 0
        return isReverse ? val1 - val2 : val2 - val1
      }
    })

    setReportData([summary, ...finalSortedData])
    return
  }

  setReportData([summary, ...newArr])
}

export const BuffetReportsVZLine = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const [isLoadingLocal, setIsLoadingLocal] = useState<boolean>(false)
  const [currentSortValue, setCurrentSortValue] = useState<null | string>(null)
  const [reportData, setReportData] = useState<IBuffetGeneralReportResult[]>([])
  const pageParams = useParamsControl<
    IBuffetGeneralReportRequest,
    keyof IBuffetGeneralReportRequest
  >({
    withPagination: false,
    whiteList: [
      'report_type',
      'dimension_date_gte',
      'dimension_date_lte',
      'dish_ids',
      'dimension_types',
      'plan_menu_type_ids',
      'dimension_time_gte',
      'dimension_time_lte',
      'internal_dish_category_ids',
      'is_dish_replaced',
      'compliant_type',
      'tag_ids',
      'plan_menu_ids',
      'value_type_dimension',
    ],
  })

  const [page, setPage] = useState(1)
  const [rows, setRows] = useState<IBuffetGeneralReportResult[]>([])

  const {
    data: generalReport,
    isLoading,
    isFetching,
  } = useGetBuffetGeneralReportQuery(
    { ...pageParams, page },
    { skip: !pageParams },
  )

  // новые фильтры → начинаем с первой страницы.
  // Сравниваем по значению: useParamsControl пересоздаёт объект на любое
  // изменение URL (например report-image-id при открытии фото)
  const filtersKey = JSON.stringify(pageParams)
  useEffect(() => setPage(1), [filtersKey])

  useEffect(() => {
    if (!generalReport) return
    setRows((prev) =>
      generalReport.page === 1
        ? generalReport.results
        : [...prev, ...generalReport.results],
    )
  }, [generalReport])

  useEffect(() => {
    if (generalReport) {
      onSortHandler(
        currentSortValue,
        rows,
        {
          ...generalReport.summary,
          id: 12,
          standardTempMax: null,
          standardTempMin: null,
          image: '',
          imageOnS3: null,
          categoryName: null,
          dates: [],
        },
        setReportData,
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rows, currentSortValue])

  const unloadDishesHandler = (type: ReportExportType) => () => {
    setIsLoadingLocal(true)
    const toastId = `report-export-${type}`
    AppNotification({
      msg: t('Формируется файл, ожидайте…'),
      type: NotificationType.info,
      autoClose: false,
      toastId,
    })
    const params = createQueryStringSmart(pageParams)
    GetFile(`${BASE_URL}${reportUrl[type as ReportExportType]}${params}`)
      .then((success) => {
        AppNotificationUpdate(toastId, {
          msg: success
            ? t('Отчет успешно выгружен!')
            : t('Не удалось сформировать отчет'),
          type: success ? NotificationType.success : NotificationType.error,
        })
      })
      .finally(() => setIsLoadingLocal(false))
  }

  const actions = useMemo(
    () => [
      {
        btnTitle: isLoadingLocal ? 'Идет выгрузка' : 'Выгрузить',
        btnIco: 'export',
        items: [
          {
            title: 'Таблица .XLSX',
            onClick: unloadDishesHandler('base'),
            ico: 'file-xlsx',
          },
          ...(pageParams?.report_type === ShowFormatType.temperature
            ? [
                {
                  title: 'Температурный журнал',
                  onClick: unloadDishesHandler('temp'),
                  ico: 'file-pdf',
                },
              ]
            : []),
          ...(pageParams?.report_type === ShowFormatType.volume
            ? [
                {
                  title: 'Бракеражный журнал',
                  onClick: unloadDishesHandler('defect'),
                  ico: 'file-pdf',
                },
                {
                  title: 'Заборный лист',
                  onClick: unloadDishesHandler('xsl'),
                  ico: 'file-xlsx',
                },
              ]
            : []),
          // { title: 'Журнал .PDF', onClick: () => {}, ico: 'file-pdf' },
          ...(pageParams?.report_type === ShowFormatType.full
            ? [
                {
                  title: 'Файл .CSV',
                  onClick: unloadDishesHandler('csv'),
                  ico: 'file-csv',
                },
              ]
            : []),
        ],
        color: AppBtnColor.whiteOutlineViolet,
        disabled: !generalReport || isLoadingLocal,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [pageParams, generalReport, isLoadingLocal],
  )

  const [isChart, setIsChart] = useState(false)
  const onChangeChart = (value: boolean) => setIsChart(value)

  const goToChart = useCallback(
    () =>
      navigate(
        `/${AllRoutes.buffetReportsVZ.path}/${
          AllRoutes.buffetReportsVZChart.path
        }/?${searchParams.toString()}`,
      ),
    [navigate, searchParams],
  )

  useEffect(() => {
    if (isChart) goToChart()
  }, [isChart, goToChart])

  const showReport = useMemo(() => {
    if (!reportData && !pageParams?.report_type && !isChart) return null
    const pagination = {
      next: generalReport?.next,
      onNextPage: () => setPage((p) => p + 1),
      isLoading: isFetching,
    }
    return {
      [ShowFormatType.full as string]: (
        <ReportFull
          reportData={reportData}
          {...pagination}
          setSearchParams={setSearchParams}
          setCurrentSortValue={setCurrentSortValue}
        />
      ),
      [ShowFormatType.volume as string]: (
        <ReportVolume
          reportData={reportData}
          {...pagination}
          setCurrentSortValue={setCurrentSortValue}
        />
      ),
      [ShowFormatType.temperature as string]: (
        <ReportTemperature
          reportData={reportData}
          {...pagination}
          setSearchParams={setSearchParams}
          setCurrentSortValue={setCurrentSortValue}
        />
      ),
      [ShowFormatType.visual as string]: (
        <ReportVisual
          reportData={reportData}
          {...pagination}
          setSearchParams={setSearchParams}
          setCurrentSortValue={setCurrentSortValue}
        />
      ),
      [ShowFormatType.intensity as string]: (
        <ReportIntensity
          reportData={reportData}
          {...pagination}
          setCurrentSortValue={setCurrentSortValue}
        />
      ),
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isChart,
    pageParams?.report_type,
    reportData,
    setSearchParams,
    generalReport?.next,
    isFetching,
  ])

  return (
    <div className="width-for-page-wrapper buffet-comparative-report-detail general-report">
      {!!isLoading && <AppLoader loaderType={LoaderType.main} />}
      {generalReport && (
        <GeneralReportImagePopup
          data={{ results: rows } as IBuffetGeneralReportListDto}
        />
      )}
      <AppTitlePage
        title={`${moment(pageParams?.dimension_date_gte).format(
          'DD.MM.YYYY',
        )} - ${moment(pageParams?.dimension_date_lte).format(
          'DD.MM.YYYY',
        )};</br> ${t(
          showFormatHeader[pageParams?.report_type as ShowFormatType],
        )}`}
        actions={actions}
        goBack
        goBackPath={`/${AllRoutes.buffetReportsVZ.path}/?${searchParams
          .toString()
          .replace(
            `&dimension_date=${searchParams.get('dimension_date')}`,
            '',
          )}`}
        isReportIntensity={pageParams?.report_type === ShowFormatType.intensity}
        isReportIntensityChart={isChart}
        onChangeChart={onChangeChart}
      />
      {!!(showReport && pageParams && pageParams.report_type) &&
        showReport[pageParams?.report_type]}
    </div>
  )
}
